<automatic-debit-breadcrumb [items]="breadcrumbItems"></automatic-debit-breadcrumb>

<loader></loader>
<form (drop)="onDrop($event)" (dragover)="onDragOver($event)">
    <label for="fileInput">Clique aqui ou arraste seus arquivos</label>
    <input id="fileInput" [multiple]="false" type="file" multiple (change)="onSelectFile($event)" />
    <p>Obs: Ao inserir/Arrastar o arquivo, o mesmo será carregado automaticamente!</p>
</form>
